export const IMAGE_SIGNATURE_SIZE = 2
export const IMAGE_SIGNATURE_SIZE_INTERMEDIATE = 6
